import { toast } from "react-toastify";

export async function withLoadingToast(
  loadingMessage: string,
  run: () => Promise<void>,
  successMessage: string | (() => string),
  errorFallback: string,
  getErrorMessage?: (err: unknown) => string,
): Promise<void> {
  const toastId = toast.loading(loadingMessage);
  try {
    await run();
    const render =
      typeof successMessage === "function" ? successMessage() : successMessage;
    toast.update(toastId, {
      render,
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
  } catch (err) {
    const render =
      getErrorMessage?.(err) ??
      (err instanceof Error ? err.message : errorFallback);
    toast.update(toastId, {
      render,
      type: "error",
      isLoading: false,
      autoClose: 5000,
    });
  }
}
